import Number from '../../../common/Number';

const mdash = '\u2014';

const getCellValue = (valueObj, index, isLastColumn) => {
  if (valueObj.hide) {
    return (
      <div
        className={`credit-info-table-cell credit-info-table-cell-value${
          isLastColumn ? ' last-column' : ''
        }`}
        key={index}
      ></div>
    );
  }

  if (valueObj.value === null && valueObj.showSuffixIfNull) {
    return (
      <div
        className="credit-info-table-cell credit-info-table-cell-value number"
        key={index}
      >
        {mdash + valueObj.suffix}
      </div>
    );
  }

  const className = valueObj.signed
    ? 'market_summary_symbol__net-change-value'
    : null;
  return (
    <div
      className={`credit-info-table-cell credit-info-table-cell-value${
        isLastColumn ? ' last-column' : ''
      }`}
      key={index}
    >
      <Number
        className={className}
        value={valueObj.value}
        precision={valueObj.precision}
        signed={valueObj.signed}
        suffix={valueObj.suffix}
      />
    </div>
  );
};

export default getCellValue;
